// 手机版
const MRouter = [{
        path: '/home_m',
        name: 'home_m',
        component: () => import( /* webpackChunkName: "home" */ '../views/home_m.vue')
    },
    {
        path: '/goods/sf_m',
        name: 'sf_m',
        // route level code-splitting
        component: () => import( /* webpackChunkName: "info" */ '../views/goods/sf_m.vue')
    },
    {
        path: '/goods/cp_m',
        name: 'cp_m',
        // route level code-splitting
        component: () => import( /* webpackChunkName: "info" */ '../views/goods/cp_m.vue')
    },
    {
        path: '/goods/cd_m',
        name: 'cd_m',
        // route level code-splitting
        component: () => import( /* webpackChunkName: "info" */ '../views/goods/cd_m.vue')
    },
]
export default MRouter